import { Tenant, WebAppCommonModule } from "@allbesmart/web-app-common";
import { Component, Input, OnChanges } from "@angular/core";
import { TenantManagementService } from "src/app/services/tenant-management.service";
import { NgClass, DatePipe } from "@angular/common";
import { WebAppKeycloakAuthModule } from "@allbesmart/web-app-keycloak-auth";

@Component({
    selector: "oaibox-deployment-details",
    templateUrl: "./deployment-details.component.html",
    styleUrls: ["./deployment-details.component.css"],
    imports: [
        WebAppCommonModule,
        NgClass,
        DatePipe,
        WebAppKeycloakAuthModule,
    ],
})
export class DeploymentDetailsComponent implements OnChanges {
  @Input({ required: true }) tenant!: Tenant;

  public tenantLogoUrl?: string;
  protected defaultTenantLogoUrl: string = "assets/images/tenant.png";

  constructor(
    private readonly tenantManagementService: TenantManagementService
  ) {}

  ngOnChanges(): void {
    if (this.tenant)
      this.tenantLogoUrl = this.tenantManagementService.getLogoUrl(
        this.tenant.id
      );
  }
}
